import { scheduleResponseSchema } from '@tempo-io/adaptive-planner-dto';
import { z } from 'zod';
import { fetchChunksWithConcurrencyLimit } from '@/common/api/chunkedFetch';
import { tempoApi } from '@/common/api/tempoApi';
import { BULK_FETCH_MAX_ITEMS } from '@/common/constants';
import { chunkBy } from '@/common/utils/chunkBy';

const scheduleBulkFetchResponseSchema = z.record(z.string(), scheduleResponseSchema);

const bulkFetch = async ({
  loopId,
  scenarioId,
  itemIds,
  signal,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  signal?: AbortSignal;
}) => {
  if (itemIds.length === 0) return {};
  const response = await tempoApi()
    .post(`api/v1/adaptive-planner/loops/${loopId}/scenarios/${scenarioId}/schedules/bulk-fetch`, {
      json: itemIds,
      signal,
    })
    .json();
  return scheduleBulkFetchResponseSchema.parse(response);
};

const bulkFetchChunked = async ({
  loopId,
  scenarioId,
  itemIds,
  signal,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  signal?: AbortSignal;
}) => {
  if (itemIds.length === 0) return {};
  if (itemIds.length <= BULK_FETCH_MAX_ITEMS) {
    return bulkFetch({ loopId, scenarioId, itemIds, signal });
  }
  const responses = await fetchChunksWithConcurrencyLimit(
    chunkBy(itemIds, BULK_FETCH_MAX_ITEMS),
    (chunk) => bulkFetch({ loopId, scenarioId, itemIds: chunk, signal }),
  );
  return Object.assign({}, ...responses);
};

export const LoopPlannerSchedulesApi = {
  bulkFetch,
  bulkFetchChunked,
} as const;
